var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {},
      [
        _c(
          "div",
          { staticClass: "back-arrow pl-6 pt-2" },
          [
            _c("router-link", { attrs: { to: "/application" } }, [
              _c("i", { staticClass: "fa fa-fw fa-arrow-left" }),
              _vm._v(" "),
              _c("span", [_vm._v(" Back to API Permissions ")]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c("base-page-heading", {
          staticClass: "d-print-none",
          attrs: { title: "Application edit", subtitle: "" },
          scopedSlots: _vm._u([
            {
              key: "extra",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      ref: "showBtn",
                      attrs: {
                        type: "submit",
                        size: "md",
                        variant: "secondary",
                      },
                      on: { click: _vm.showModal },
                    },
                    [
                      _c("i", { staticClass: "fa fa-fw fa-plus" }),
                      _vm._v(" \tCreate new\n\t\t\t\t"),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row content" },
          [
            _c("EditApiPermissionTable", {
              attrs: { "route-id": _vm.routeId },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }